// @flow
import type { Action } from "../actions/types";
import {
  START_SYNC,
  COMPLETE_SYNC,
  SYNC_ERROR
} from "../actions/types";

const initialState = {
  syncing: false,
  syncError: null
};

export const appReducer = (
  state: typeof initialState = initialState,
  action: Action
): typeof initialState => {
  const { type, payload } = action;
  switch (type) {
    case START_SYNC:
      return {
        ...state,
        syncing: true,
      };

    case COMPLETE_SYNC:
      return {
        ...state,
        syncing: false,
      };

    case SYNC_ERROR:
      return {
        ...state,
        syncing: false,
        error: payload
      };

    default:
      return state;
  }
};
